export default __webpack_public_path__ + "static/media/kdsImage.91c36a15.png";